import './comp_live_fecthing.css';

const Comp_Live_Fetching = (props) => {
  return (
    <div className="live-fetchng-sectn">
      <div className="row11 justify-content-center">
       <div className="activity-box">
  <img
    src="./castrol.png"
    alt="Oil Bottle"
    className="bottle-img"
  />
  <div className="activity-content">
    <div className="activity-header">
      <h4 className="activity-title">Oil Change Activity</h4>
    </div>
    {/* <div className="activity-location text-start">
      at SpeedMax Auto Ranchi
    </div> */}
    <div className="data-row">
      <div className="data-fetching">
        <span>
          <strong id="count_notification_kor"></strong>.
        </span>
        <div className="loading-bar"></div>
      </div>
    </div>
  </div>
</div>
      </div>
    </div>
  );
};

export default Comp_Live_Fetching;
 
